import React from 'react'

export default function Required() {
  return (
    <div className="color-red">
      <div style={{padding: `0 0 0 0`}}>* Required</div>
    </div>
  )
}
